<template>
  <PageLayout>
    <template v-slot:header>
      <div class="ui padded grid">
        <div class="row">
          <div class="eight wide column">
            <Breadcrumb>
              <div class="active section">Permissões</div>
            </Breadcrumb>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:main>
      <form
        :class="['ui small', { error: anyError }, 'form relative']"
        @submit.prevent="save"
      >
        <div class="ui padded grid">
          <div v-show="loading" class="ui active inverted dimmer">
            <div class="ui text loader">Carregando...</div>
          </div>
          <div class="row">
            <div class="six wide column">
              <div class="ui raised segment">
                <h4 class="ui dividing header">Perfis de Acesso</h4>
                <ul>
                  <li v-for="(profile, index) in profiles" :key="index">
                    <a
                      :class="{ bold: currentProfileId == profile.id }"
                      @click.prevent="openPermissions(profile.id)"
                      >{{ profile.description }}</a
                    >
                  </li>
                </ul>
              </div>
            </div>
            <div class="ten wide column relative">
              <div v-show="loadingProfile" class="ui active inverted dimmer">
                <div class="ui text loader">Carregando Acessos...</div>
              </div>
              <h4 v-if="currentProfileId == null" class="ui centered header">
                Selecione um Perfil de Acesso
              </h4>
              <div v-if="currentProfileId != null" class="neutral">
                <h4 class="ui dividing centered header">
                  Permissões do Perfil de Acesso -
                  {{ currentProfile.description }}
                </h4>
                <ul>
                  <li
                    v-for="(fatherPermission, fatherIndex) in fatherPermissions"
                    :key="fatherIndex"
                    class="father"
                  >
                    <input
                      type="checkbox"
                      :value="fatherPermission.id"
                      v-model="selectedPermissions"
                    />
                    {{ fatherPermission.description }}
                    <ul>
                      <li
                        v-for="(
                          childPermission, childIndex
                        ) in childrensPermissions(fatherPermission.id)"
                        :key="`${fatherIndex}-${childIndex}`"
                      >
                        <input
                          type="checkbox"
                          :value="childPermission.id"
                          v-model="selectedPermissions"
                        />
                        {{ childPermission.description }}
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- row -->
          <div class="row">
            <div class="sixteen wide column">
              <div class="ui divider"></div>
              <div class="field">
                <button
                  @click="save"
                  type="button"
                  name="save"
                  class="ui submit blue button"
                >
                  <i class="save icon"></i>Salvar
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- grid -->
      </form>
    </template>
  </PageLayout>
</template>

<script>
import Api from '@/resources/Api';
import CepResource from '@/resources/Cep';
import Breadcrumb from '@/components/breadcrumb';
import PageLayout from '@/layouts/page_layout';

export default {
  name: 'users',
  components: { Breadcrumb, PageLayout },

  data() {
    return {
      loading: false,
      loadingProfile: false,
      currentProfileId: null,
      errors: {},
      profiles: [],
      userAccessPermissions: [],
      selectedPermissions: [],
      accessPermissions: []
    };
  },

  computed: {
    anyError() {
      return !_.isEmpty(this.errors);
    },

    fatherPermissions() {
      return _.sortBy(
        this.accessPermissions.filter(a => a.father_id == null),
        ['description']
      );
    },

    currentProfile() {
      return this.profiles.find(x => x.id == this.currentProfileId) || {};
    }
  },

  mounted() {
    this.init();
  },

  methods: {
    init() {
      this.getAccessPermissions();
      this.getProfiles();
    },

    openPermissions(profileId) {
      this.currentProfileId = profileId;
      this.fetchProfile(this.currentProfileId);
    },

    childrensPermissions(fatherId) {
      return _.sortBy(
        this.accessPermissions.filter(p => p.father_id == fatherId),
        ['description']
      );
    },

    errorsTo(key) {
      const errors = _.isEmpty(this.errors[key]) ? [] : this.errors[key];
      return errors.join(', ');
    },

    _setErrors(errors) {
      this.errors = _.clone(errors);
      setTimeout(() => {
        $('.error.field').popup();
      }, 100);
    },

    openHistory() {
      this.$refs.history.open();
    },

    save() {
      this.loading = true;
      this._setErrors({});
      const userAccessPermissionsAttributes = [];

      this.selectedPermissions.forEach(selectedPermission => {
        const userAccessPermission = this.userAccessPermissions.find(
          permission => permission.access_permission_id == selectedPermission
        );
        if (userAccessPermission) {
          userAccessPermissionsAttributes.push({
            id: userAccessPermission.id,
            profile_id: this.currentProfileId,
            access_permission_id: userAccessPermission.access_permission_id
          });
        } else {
          userAccessPermissionsAttributes.push({
            profile_id: this.currentProfileId,
            access_permission_id: selectedPermission
          });
        }
      });

      const userAccessPermissionsToRemove = this.userAccessPermissions.filter(
        userAccessPermission =>
          !this.selectedPermissions.includes(
            userAccessPermission.access_permission_id
          )
      );
      userAccessPermissionsToRemove.forEach(userAccessToRemove => {
        userAccessPermissionsAttributes.push({
          id: userAccessToRemove.id,
          profile_id: userAccessToRemove.profile_id,
          access_permission_id: userAccessToRemove.access_permission_id,
          _destroy: true
        });
      });

      const data = {
        id: this.currentProfileId,
        user_access_permissions_attributes: userAccessPermissionsAttributes
      };

      Api.profiles
        .save(data)
        .then(() => {
          this.$toast.show('Permissões salvas com sucesso', 'success');
        })
        .catch(error => {
          if (error.response) {
            this.$toast.show('Erro ao salvar permissões', 'error');
          } else {
            throw error;
          }
        })
        .finally(() => {
          this.$scrollTop();
          this.loading = false;
        });
    },

    getProfiles() {
      this.loading = true;
      Api.profiles
        .search({})
        .then(async response => {
          this.profiles = _.sortBy(response.data.profiles, 'description');
        })
        .catch(error => {
          this.$toast.show('Erro ao buscar Perfis de Acesso', 'error');
          throw error;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    getAccessPermissions() {
      this.loading = true;
      Api.access_permissions()
        .then(async response => {
          this.accessPermissions = _.clone(response.data.access_permissions);
        })
        .catch(error => {
          this.$toast.show('Erro ao buscar dados de acessos', 'error');
          throw error;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    fetchProfile(id) {
      this.loading = true;
      Api.profiles
        .fetch(id)
        .then(async response => {
          this.userAccessPermissions = _.clone(
            response.data.profile.user_access_permissions
          );

          const selectedPermissions = this.userAccessPermissions.map(
            p => p.access_permission_id
          );
          this.selectedPermissions = _.clone(selectedPermissions);
        })
        .catch(error => {
          if (error.response) {
            this.$toast.show('Erro ao buscar Perfil de Acesso', 'error');
            // this.$router.push({name: 'profiles'});
          } else {
            throw error;
          }
        })
        .finally(() => {
          this.$scrollTop();
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="css" scoped>
/* li.father {
    padding-bottom: 1rem;
  } */

/* li{margin-bottom: 5px} */
</style>
